import axios from 'axios';
import API_BASE_URL from '../config/api.js';

/**
 * Fetch simplified catalog analytics (raw data stored in S3)
 */
export const getCatalogAnalytics = async (artistId = 'rdv01') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/catalog/analytics`, {
      params: { artistId }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching catalog analytics:', error);
    return {
      metrics: { totalTracks: 0, avgViralScore: 0, marketingReady: 0, completionRate: 0 },
      insights: { topPerformers: [], readyForSync: 0, highViralPotential: 0 },
      growth: [],
      marketing: {
        campaignReady: [],
        allTracks: [],
        brandOpportunities: {},
        optimalPostingTimes: {}
      }
    };
  }
};

/**
 * Fetch viral predictions analytics
 */
export const getPredictionsAnalytics = async (artistId = 'rdv01') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/catalog/analytics`, {
      params: { artistId }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching predictions analytics:', error);
    return {
      viralMetrics: { highPotential: 0, readyTracks: 0, avgScore: 0 },
      recommendations: []
    };
  }
};

/**
 * Fetch growth analytics (main dashboard)
 */
export const getGrowthAnalytics = async (artistId = 'rdv01') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/analytics`, {
      params: { artistId }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching growth analytics:', error);
    return {
      totalStreams: 0,
      monthlyGrowth: 0,
      topTracks: [],
      recentGrowth: []
    };
  }
};

/**
 * Fetch Spotify analytics
 */
export const getSpotifyAnalytics = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/spotify/analytics`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Spotify analytics:', error);
    return {
      followers: 0,
      monthlyListeners: 0,
      topTracks: [],
      playlists: []
    };
  }
};

/**
 * Fetch accounting analytics
 */
export const getAccountingAnalytics = async (artistId = 'rdv01') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/accounting`, {
      params: { artistId }  // Fixed: use consistent parameter name
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching accounting analytics:', error);
    return {
      totalRevenue: 0,
      monthlyRevenue: 0,
      streamRevenue: 0,
      syncRevenue: 0
    };
  }
};
